export default __webpack_public_path__ + "static/media/newmizusushi.11775820.jpeg";